import { useSingleSchema } from "../../../hooks/useSchema";
import { useSmartList } from "../../../hooks/useSmartList";
import { InputDefinition, RuleDefinition, OutputFieldDefinition } from "../types";

export interface CalculatorConfigRecord {
  _id: string;
  title: string;
  description?: string;
  description_more?: string;
  inputs?: InputDefinition[];
  rules?: RuleDefinition[];
  outputs?: OutputFieldDefinition[];
  created_at?: string;
  created_by?: string;
  updated_at?: string;
  updated_by?: string;
}

export const DefaultCalculatorApiPath = `/api/calculator/config`;

export const useCalculatorConfigsList = (apiPath: string = DefaultCalculatorApiPath) => {
  const schema = useSingleSchema(`${apiPath}/uiconfig`);
  const data = useSmartList<CalculatorConfigRecord>(apiPath, {
    newRecordDefault: {
      title: "",
      description: "",
      inputs: [],
      rules: [],
      outputs: [],
    } as any,
    schema: schema.schema,
  });

  return data;
};
